import clsx from 'clsx';
import type { SuperSearchStatus } from '@/api/types';
import { statusLabel, statusTone } from '@/lib/format';

const tones = {
  good: 'bg-emerald-500/10 text-emerald-300 ring-emerald-500/30',
  waiting: 'bg-amber-500/10 text-amber-300 ring-amber-500/30',
  bad: 'bg-rose-500/10 text-rose-300 ring-rose-500/30',
} as const;

export function StatusPill({ status }: { status: SuperSearchStatus }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
        tones[statusTone[status]],
      )}
    >
      <span className="size-1.5 rounded-full bg-current" />
      {statusLabel[status]}
    </span>
  );
}
